module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar p-0 navbar-light justify-content-between flex-nowrap flex-row fixed-top"
  }, [_c('div', {
    staticClass: "container-fuild w-100"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'top',
        params: {}
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/photo_spot_international_header_logo.png")
    }
  })]), _vm._v(" "), _c('header-right-menu-mobile', {
    attrs: {
      "iconSizeClass": "fa-3x",
      "headerHeight": "50"
    },
    on: {
      "logout": _vm.logout
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e84d7d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/partials/GuestHeader/MobileHeader.vue
// module id = 724
// module chunks = 0